// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}
ion-header::after {
  display: none;
}
ion-header ion-toolbar {
  --background: linear-gradient(180deg, var(--ion-color-light-tint), var(--ion-background-color));
  --border-width: 0 0 1px 0;
  --border-color: var(--ion-color-light-shade);
}
ion-header ion-toolbar ion-title {
  font-weight: 600;
}

.form-close-icon {
  margin-left: 0.5rem;
  font-size: 1.7rem;
}

ion-footer {
  box-shadow: none;
  background: var(--ion-background-color);
}
ion-footer::before {
  display: none;
}

.footer-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-top: 1px solid var(--ion-color-light-shade);
}
.footer-bar ion-spinner {
  margin: 12px auto;
}
.footer-bar .footer-btn {
  width: 100%;
  max-width: 480px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-grid ion-item {
  --min-height: 48px;
  --padding-start: 8px;
  --inner-padding-end: 4px;
}
.form-grid ion-note[slot=helper] {
  font-size: 0.72rem;
  line-height: 1.2;
  margin-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.form-grid ion-card {
  margin: 0;
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 8px;
  box-shadow: none;
  background: var(--ion-card-background, var(--ion-background-color));
}
.form-grid ion-card-header {
  padding: 10px 14px;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid var(--ion-color-light-shade);
  background: linear-gradient(180deg, var(--ion-color-light-tint), var(--ion-card-background, var(--ion-background-color)));
}
.form-grid ion-card-content {
  padding: 12px 14px;
}
.form-grid ion-card-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ion-text-color);
}
.form-grid ion-card-subtitle {
  margin-top: 2px;
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--ion-color-medium);
  text-transform: none;
  letter-spacing: normal;
}
.form-grid .toggle-helper {
  display: block;
  font-size: 0.72rem;
  margin: -2px 0 8px 12px;
  line-height: 1.15;
}
.form-grid .lock-note {
  display: block;
  font-size: 0.72rem;
  margin: -4px 0 8px;
}
.form-grid .advanced-sections {
  margin: 0;
}
.form-grid .advanced-sections ion-accordion {
  margin-bottom: 6px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--ion-color-light-shade);
}
.form-grid .advanced-sections ion-accordion ion-item[slot=header] {
  --background: linear-gradient(
    180deg,
    var(--ion-color-light-tint),
    var(--ion-card-background, var(--ion-background-color))
  );
  --min-height: 44px;
  font-weight: 600;
}
.form-grid .advanced-sections ion-accordion ion-item[slot=header] ion-icon {
  color: var(--ion-color-primary);
}
.form-grid .advanced-sections ion-accordion [slot=content] {
  padding: 8px 10px 10px;
}
.form-grid .advanced-sections.inner {
  margin: 6px 0 2px;
}
.form-grid .advanced-sections.inner ion-accordion {
  border: 1px dashed var(--ion-color-light-shade);
}
.form-grid .advanced-sections.inner ion-accordion ion-item[slot=header] {
  --background: transparent;
  --min-height: 38px;
  font-weight: 500;
  font-size: 0.85rem;
}
.form-grid .accordion-hint {
  font-size: 0.78rem;
  color: var(--ion-color-medium);
  margin: 4px 8px 8px;
}
.form-grid .cards-row-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media (min-width: 900px) {
  .form-grid .cards-row-2 {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
}
.form-grid .fields-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 8px;
}
@media (max-width: 480px) {
  .form-grid .fields-row-2 {
    grid-template-columns: 1fr;
  }
}
.form-grid .fields-row-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px 8px;
}
@media (max-width: 600px) {
  .form-grid .fields-row-3 {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 400px) {
  .form-grid .fields-row-3 {
    grid-template-columns: 1fr;
  }
}
.form-grid .address-grid {
  display: grid;
  grid-template-columns: 1fr 100px 80px;
  gap: 4px 8px;
}
@media (max-width: 480px) {
  .form-grid .address-grid {
    grid-template-columns: 1fr 1fr;
  }
  .form-grid .address-grid > ion-item:last-child {
    grid-column: 1/-1;
  }
}
.form-grid .config-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 12px;
}
.form-grid .config-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.form-grid .config-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--ion-color-medium);
}
.form-grid .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  color: var(--ion-color-medium);
}
.form-grid .empty-state ion-icon {
  font-size: 2rem;
  opacity: 0.45;
}
.form-grid .empty-state p {
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
  max-width: 28ch;
  text-wrap: balance;
}

.articolo-readonly {
  display: flex;
  flex-direction: column;
  padding: 8px 4px 4px;
  margin-bottom: 4px;
}
.articolo-readonly__label {
  font-size: 0.75rem;
  color: var(--ion-color-medium);
  margin-bottom: 2px;
}
.articolo-readonly__value {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.articolo-readonly__cod {
  font-family: var(--ion-font-family-monospace, monospace);
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--ion-color-primary);
}
.articolo-readonly__var {
  font-size: 0.875rem;
  color: var(--ion-color-medium);
}

.mat-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mat-row {
  border-radius: 8px;
  border: 1px solid var(--ion-color-light-shade);
  border-left: 4px solid var(--ion-color-primary-tint);
  background: var(--ion-card-background, var(--ion-background-color));
  overflow: hidden;
  transition: border-color 0.15s;
}
.mat-row:hover {
  border-color: var(--ion-color-medium-tint);
  border-left-color: var(--ion-color-primary);
}

.mat-row-desktop {
  display: none;
}
@media (min-width: 640px) {
  .mat-row-desktop {
    display: grid;
    grid-template-columns: 60px 1fr 2fr 80px 80px 70px;
    align-items: center;
    font-size: 0.875rem;
  }
}

.mat-row-mobile {
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  gap: 4px;
}
@media (min-width: 640px) {
  .mat-row-mobile {
    display: none;
  }
}
.mat-row-mobile__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mat-row-mobile__id {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.mat-row-mobile__fase {
  font-size: 0.75rem;
  color: var(--ion-color-primary);
  flex-shrink: 0;
}
.mat-row-mobile__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.mat-row-mobile__desc {
  font-size: 0.875rem;
  color: var(--ion-text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mat-row-mobile__qty {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 0.875rem;
}
.mat-row-mobile__consumed {
  margin-left: 8px;
  font-size: 0.75rem;
  color: var(--ion-color-success);
}

.mat-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border-right: 1px solid var(--ion-color-light-shade);
}
.mat-cell:last-child {
  border-right: none;
}
.mat-cell--code, .mat-cell--desc {
  align-items: flex-start;
}
.mat-cell--desc {
  min-width: 0;
}
.mat-cell__label {
  font-size: 0.65rem;
  color: var(--ion-color-medium);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.mat-cell__cod {
  font-family: var(--ion-font-family-monospace, monospace);
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--ion-color-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mat-cell__sub {
  font-size: 0.7rem;
  color: var(--ion-color-medium);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mat-cell__desc-text {
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.mat-cell__esterno {
  font-size: 0.7rem;
  color: var(--ion-color-tertiary, #6c47ff);
  margin-top: 2px;
}
.mat-cell__fase-num {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ion-color-primary);
}
.mat-cell__qty-val {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.mat-cell__um {
  font-family: var(--ion-font-family-monospace, monospace);
  font-size: 0.7rem;
  color: var(--ion-color-medium);
}
.mat-cell__consumed-val {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--ion-color-medium);
}
.mat-cell__consumed-val--positive {
  color: var(--ion-color-success);
}

.mat-cell--actions {
  flex-direction: column;
  gap: 4px;
  border-right: none;
}

.mat-action-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.1s;
  background: transparent;
}
.mat-action-btn ion-icon {
  font-size: 0.875rem;
}
.mat-action-btn:active {
  transform: scale(0.93);
}
.mat-action-btn--edit {
  color: var(--ion-color-primary);
  background: color-mix(in srgb, var(--ion-color-primary) 10%, transparent);
}
.mat-action-btn--edit:hover {
  background: color-mix(in srgb, var(--ion-color-primary) 18%, transparent);
}
.mat-action-btn--delete {
  color: var(--ion-color-danger);
  background: color-mix(in srgb, var(--ion-color-danger) 10%, transparent);
}
.mat-action-btn--delete:hover {
  background: color-mix(in srgb, var(--ion-color-danger) 18%, transparent);
}

.verifica-esito {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin: 0.25rem 0 0.5rem;
}
.verifica-esito ion-note {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
}
.verifica-esito .verifica-occupato {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}`, "",{"version":3,"sources":["webpack://./src/theme/_form-modal.scss","webpack://./src/app/vendita/ordine-vendita-create/ordine-vendita-create.component.scss"],"names":[],"mappings":"AAgBA;EACE,gBAAA;ACfF;ADiBE;EAAW,aAAA;ACdb;ADgBE;EACE,+FAAA;EACA,yBAAA;EACA,4CAAA;ACdJ;ADgBI;EACE,gBAAA;ACdN;;ADmBA;EACE,mBAAA;EACA,iBAAA;AChBF;;ADqBA;EACE,gBAAA;EACA,uCAAA;AClBF;ADoBE;EAAY,aAAA;ACjBd;;ADoBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kDAAA;ACjBF;ADmBE;EACE,iBAAA;ACjBJ;ADoBE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AClBJ;;ADwBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACrBF;ADyBE;EACE,kBAAA;EACA,oBAAA;EACA,wBAAA;ACvBJ;AD2BE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;ACzBJ;AD8BE;EACE,SAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;EACA,mEAAA;AC5BJ;AD+BE;EACE,kBAAA;EACA,0BAAA;EACA,qDAAA;EACA,yHAAA;AC7BJ;ADoCE;EACE,kBAAA;AClCJ;ADqCE;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;ACnCJ;ADsCE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,oBAAA;EACA,sBAAA;ACpCJ;ADyCE;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;ACvCJ;AD0CE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;ACxCJ;AD6CE;EACE,SAAA;AC3CJ;AD6CI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC3CN;AD8CI;EACE;;;;GAAA;EAKA,kBAAA;EACA,gBAAA;AC5CN;AD8CM;EAAW,+BAAA;AC3CjB;AD8CI;EACE,sBAAA;AC5CN;ADgDI;EACE,iBAAA;AC9CN;ADgDM;EACE,+CAAA;AC9CR;ADiDM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AC/CR;ADoDE;EACE,kBAAA;EACA,8BAAA;EACA,mBAAA;AClDJ;ADuDE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;ACrDJ;ADuDI;EALF;IAMI,8BAAA;IACA,kBAAA;ECpDJ;AACF;ADuDE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;ACrDJ;ADuDI;EALF;IAMI,0BAAA;ECpDJ;AACF;ADuDE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;ACrDJ;ADuDI;EALF;IAMI,8BAAA;ECpDJ;AACF;ADsDI;EATF;IAUI,0BAAA;ECnDJ;AACF;ADsDE;EACE,aAAA;EACA,qCAAA;EACA,YAAA;ACpDJ;ADsDI;EALF;IAMI,8BAAA;ECnDJ;EDqDI;IACE,iBAAA;ECnDN;AACF;ADyDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;ACvDJ;AD0DE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;ACxDJ;AD2DE;EACE,mBAAA;EACA,gBAAA;EACA,8BAAA;ACzDJ;AD8DE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,8BAAA;AC5DJ;AD8DI;EACE,eAAA;EACA,aAAA;AC5DN;AD+DI;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AC7DN;;AA9NA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;AAiOF;AA/NE;EACE,kBAAA;EACA,8BAAA;EACA,kBAAA;AAiOJ;AA9NE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAgOJ;AA7NE;EACE,wDAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;AA+NJ;AA5NE;EACE,mBAAA;EACA,8BAAA;AA8NJ;;AAxNA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA2NF;;AAxNA;EACE,kBAAA;EACA,8CAAA;EACA,oDAAA;EACA,mEAAA;EACA,gBAAA;EACA,8BAAA;AA2NF;AAzNE;EACE,0CAAA;EACA,2CAAA;AA2NJ;;AAtNA;EACE,aAAA;AAyNF;AAvNE;EAHF;IAII,aAAA;IACA,kDAAA;IACA,mBAAA;IACA,mBAAA;EA0NF;AACF;;AAtNA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAyNF;AAvNE;EANF;IAOI,aAAA;EA0NF;AACF;AAxNE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA0NJ;AAvNE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AAyNJ;AAtNE;EACE,kBAAA;EACA,+BAAA;EACA,cAAA;AAwNJ;AArNE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAuNJ;AApNE;EACE,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAsNJ;AAnNE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;AAqNJ;AAlNE;EACE,gBAAA;EACA,kBAAA;EACA,+BAAA;AAoNJ;;AA/MA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,oDAAA;AAkNF;AAhNE;EACE,kBAAA;AAkNJ;AA/ME;EAEE,uBAAA;AAgNJ;AA7ME;EACE,YAAA;AA+MJ;AA5ME;EACE,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AA8MJ;AA3ME;EACE,wDAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA6MJ;AA1ME;EACE,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA4MJ;AAzME;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA2MJ;AAxME;EACE,iBAAA;EACA,yCAAA;EACA,eAAA;AA0MJ;AAvME;EACE,gBAAA;EACA,kCAAA;EACA,+BAAA;AAyMJ;AAtME;EACE,gBAAA;EACA,kCAAA;AAwMJ;AArME;EACE,wDAAA;EACA,iBAAA;EACA,8BAAA;AAuMJ;AApME;EACE,gBAAA;EACA,kCAAA;EACA,8BAAA;AAsMJ;AApMI;EACE,+BAAA;AAsMN;;AAjMA;EACE,sBAAA;EACA,QAAA;EACA,kBAAA;AAoMF;;AA/LA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kDAAA;EACA,uBAAA;AAkMF;AAhME;EACE,mBAAA;AAkMJ;AA/LE;EACE,sBAAA;AAiMJ;AA9LE;EACE,+BAAA;EACA,yEAAA;AAgMJ;AA9LI;EACE,yEAAA;AAgMN;AA5LE;EACE,8BAAA;EACA,wEAAA;AA8LJ;AA5LI;EACE,wEAAA;AA8LN;;AAxLA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;AA2LF;AAzLE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA2LJ;AAxLE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA0LJ","sourcesContent":["// ════════════════════════════════════════════════════════════════════════════\n// Stile condiviso modali \"create\" — form GitHub-style\n// Importato da: ordine-vendita-create, anagrafica-create, articoli-prodotti-create\n//\n// Linguaggio visivo: card con bordi sottili 1px, niente ombra, arrotondamenti\n// leggeri (8px), header con sfumatura grigio neutro + separatore, informazioni\n// ben chiare. Tutto token-driven (--ion-color-*, --ion-card-background, ...) →\n// il dark mode si adatta da solo (token ridefiniti in body.dark).\n//\n// Le regole interne al form sono scopate sotto `.form-grid` (presente in tutte e\n// tre le modali) per vincere con certezza sulle regole `:host` di Ionic.\n// Toolbar e footer stanno fuori da `.form-grid` → regole a livello radice.\n// ════════════════════════════════════════════════════════════════════════════\n\n// ─── Header del modale (toolbar con sfumatura neutra) ────────────────────────\n\nion-header {\n  box-shadow: none;\n\n  &::after { display: none; } // rimuove l'ombra md di default\n\n  ion-toolbar {\n    --background: linear-gradient(180deg, var(--ion-color-light-tint), var(--ion-background-color));\n    --border-width: 0 0 1px 0;\n    --border-color: var(--ion-color-light-shade);\n\n    ion-title {\n      font-weight: 600;\n    }\n  }\n}\n\n.form-close-icon {\n  margin-left: 0.5rem;\n  font-size: 1.7rem;\n}\n\n// ─── Footer del modale ───────────────────────────────────────────────────────\n\nion-footer {\n  box-shadow: none;\n  background: var(--ion-background-color);\n\n  &::before { display: none; } // rimuove l'ombra md di default\n}\n\n.footer-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border-top: 1px solid var(--ion-color-light-shade);\n\n  ion-spinner {\n    margin: 12px auto;\n  }\n\n  .footer-btn {\n    width: 100%;\n    max-width: 480px;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n  }\n}\n\n// ─── Contenuto form ──────────────────────────────────────────────────────────\n\n.form-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  // ── Compattazione campi ───────────────────────────────────────────────────\n\n  ion-item {\n    --min-height: 48px;\n    --padding-start: 8px;\n    --inner-padding-end: 4px;\n  }\n\n  // Helper leggibile su massimo 2 righe (niente troncamento a 1 riga)\n  ion-note[slot=\"helper\"] {\n    font-size: 0.72rem;\n    line-height: 1.2;\n    margin-top: 2px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  // ── Card \"Box\" GitHub-style ───────────────────────────────────────────────\n\n  ion-card {\n    margin: 0;\n    border: 1px solid var(--ion-color-light-shade);\n    border-radius: 8px;\n    box-shadow: none;\n    background: var(--ion-card-background, var(--ion-background-color));\n  }\n\n  ion-card-header {\n    padding: 10px 14px;\n    border-radius: 8px 8px 0 0;\n    border-bottom: 1px solid var(--ion-color-light-shade);\n    background: linear-gradient(\n      180deg,\n      var(--ion-color-light-tint),\n      var(--ion-card-background, var(--ion-background-color))\n    );\n  }\n\n  ion-card-content {\n    padding: 12px 14px;\n  }\n\n  ion-card-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: var(--ion-text-color);\n  }\n\n  ion-card-subtitle {\n    margin-top: 2px;\n    font-size: 0.75rem;\n    font-weight: 400;\n    color: var(--ion-color-medium);\n    text-transform: none;     // override del maiuscoletto Ionic → leggibilità\n    letter-spacing: normal;\n  }\n\n  // ── Helper inline (toggle / lock) ─────────────────────────────────────────\n\n  .toggle-helper {\n    display: block;\n    font-size: 0.72rem;\n    margin: -2px 0 8px 12px;\n    line-height: 1.15;\n  }\n\n  .lock-note {\n    display: block;\n    font-size: 0.72rem;\n    margin: -4px 0 8px;\n  }\n\n  // ── Accordion sezioni avanzate ────────────────────────────────────────────\n\n  .advanced-sections {\n    margin: 0;\n\n    ion-accordion {\n      margin-bottom: 6px;\n      border-radius: 8px;\n      overflow: hidden;\n      border: 1px solid var(--ion-color-light-shade);\n    }\n\n    ion-accordion ion-item[slot=\"header\"] {\n      --background: linear-gradient(\n        180deg,\n        var(--ion-color-light-tint),\n        var(--ion-card-background, var(--ion-background-color))\n      );\n      --min-height: 44px;\n      font-weight: 600;\n\n      ion-icon { color: var(--ion-color-primary); }\n    }\n\n    ion-accordion [slot=\"content\"] {\n      padding: 8px 10px 10px;\n    }\n\n    // Accordion annidati (es. \"Indirizzo dettagliato\", \"U.M. aggiuntiva\")\n    &.inner {\n      margin: 6px 0 2px;\n\n      ion-accordion {\n        border: 1px dashed var(--ion-color-light-shade);\n      }\n\n      ion-accordion ion-item[slot=\"header\"] {\n        --background: transparent;\n        --min-height: 38px;\n        font-weight: 500;\n        font-size: 0.85rem;\n      }\n    }\n  }\n\n  .accordion-hint {\n    font-size: 0.78rem;\n    color: var(--ion-color-medium);\n    margin: 4px 8px 8px;\n  }\n\n  // ── Griglie responsive condivise ──────────────────────────────────────────\n\n  .cards-row-2 {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n\n    @media (min-width: 900px) {\n      grid-template-columns: 1fr 1fr;\n      align-items: start;\n    }\n  }\n\n  .fields-row-2 {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 4px 8px;\n\n    @media (max-width: 480px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .fields-row-3 {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 4px 8px;\n\n    @media (max-width: 600px) {\n      grid-template-columns: 1fr 1fr;\n    }\n\n    @media (max-width: 400px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .address-grid {\n    display: grid;\n    grid-template-columns: 1fr 100px 80px;\n    gap: 4px 8px;\n\n    @media (max-width: 480px) {\n      grid-template-columns: 1fr 1fr;\n\n      > ion-item:last-child {\n        grid-column: 1 / -1;\n      }\n    }\n  }\n\n  // ── Blocco configurazione (toggle stato record) ───────────────────────────\n\n  .config-block {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-top: 12px;\n  }\n\n  .config-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .config-label {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: var(--ion-color-medium);\n  }\n\n  // ── Empty / info state ────────────────────────────────────────────────────\n\n  .empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 32px 16px;\n    color: var(--ion-color-medium);\n\n    ion-icon {\n      font-size: 2rem;\n      opacity: 0.45;\n    }\n\n    p {\n      font-size: 0.875rem;\n      margin: 0;\n      text-align: center;\n      max-width: 28ch;\n      text-wrap: balance;\n    }\n  }\n}\n","@use '../../../theme/form-modal' as *;\n\n// Stile specifico della modale ordine di vendita.\n// Il \"chrome\" condiviso (card Box-style, header sfumato, accordion, griglie,\n// footer, empty-state) arriva dal partial _form-modal.scss.\n\n// ─── Articolo readonly display ────────────────────────────────────────────────\n\n.articolo-readonly {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 4px 4px;\n  margin-bottom: 4px;\n\n  &__label {\n    font-size: 0.75rem;\n    color: var(--ion-color-medium);\n    margin-bottom: 2px;\n  }\n\n  &__value {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n  }\n\n  &__cod {\n    font-family: var(--ion-font-family-monospace, monospace);\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--ion-color-primary);\n  }\n\n  &__var {\n    font-size: 0.875rem;\n    color: var(--ion-color-medium);\n  }\n}\n\n// ─── Materiale list ───────────────────────────────────────────────────────────\n\n.mat-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mat-row {\n  border-radius: 8px;\n  border: 1px solid var(--ion-color-light-shade);\n  border-left: 4px solid var(--ion-color-primary-tint);\n  background: var(--ion-card-background, var(--ion-background-color));\n  overflow: hidden;\n  transition: border-color 0.15s;\n\n  &:hover {\n    border-color: var(--ion-color-medium-tint);\n    border-left-color: var(--ion-color-primary);\n  }\n}\n\n// Desktop row: grid columns\n.mat-row-desktop {\n  display: none;\n\n  @media (min-width: 640px) {\n    display: grid;\n    grid-template-columns: 60px 1fr 2fr 80px 80px 70px;\n    align-items: center;\n    font-size: 0.875rem;\n  }\n}\n\n// Mobile row\n.mat-row-mobile {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px;\n  gap: 4px;\n\n  @media (min-width: 640px) {\n    display: none;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__id {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__fase {\n    font-size: 0.75rem;\n    color: var(--ion-color-primary);\n    flex-shrink: 0;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n\n  &__desc {\n    font-size: 0.875rem;\n    color: var(--ion-text-color);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__qty {\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n    font-size: 0.875rem;\n  }\n\n  &__consumed {\n    margin-left: 8px;\n    font-size: 0.75rem;\n    color: var(--ion-color-success);\n  }\n}\n\n// Shared cell\n.mat-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px;\n  border-right: 1px solid var(--ion-color-light-shade);\n\n  &:last-child {\n    border-right: none;\n  }\n\n  &--code,\n  &--desc {\n    align-items: flex-start;\n  }\n\n  &--desc {\n    min-width: 0;\n  }\n\n  &__label {\n    font-size: 0.65rem;\n    color: var(--ion-color-medium);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  &__cod {\n    font-family: var(--ion-font-family-monospace, monospace);\n    font-size: 0.875rem;\n    font-weight: 700;\n    color: var(--ion-color-primary);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n  }\n\n  &__sub {\n    font-size: 0.7rem;\n    color: var(--ion-color-medium);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n  }\n\n  &__desc-text {\n    font-size: 0.875rem;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n  }\n\n  &__esterno {\n    font-size: 0.7rem;\n    color: var(--ion-color-tertiary, #6c47ff);\n    margin-top: 2px;\n  }\n\n  &__fase-num {\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    color: var(--ion-color-primary);\n  }\n\n  &__qty-val {\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__um {\n    font-family: var(--ion-font-family-monospace, monospace);\n    font-size: 0.7rem;\n    color: var(--ion-color-medium);\n  }\n\n  &__consumed-val {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    color: var(--ion-color-medium);\n\n    &--positive {\n      color: var(--ion-color-success);\n    }\n  }\n}\n\n.mat-cell--actions {\n  flex-direction: column;\n  gap: 4px;\n  border-right: none;\n}\n\n// ─── Action buttons ───────────────────────────────────────────────────────────\n\n.mat-action-btn {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s, transform 0.1s;\n  background: transparent;\n\n  ion-icon {\n    font-size: 0.875rem;\n  }\n\n  &:active {\n    transform: scale(0.93);\n  }\n\n  &--edit {\n    color: var(--ion-color-primary);\n    background: color-mix(in srgb, var(--ion-color-primary) 10%, transparent);\n\n    &:hover {\n      background: color-mix(in srgb, var(--ion-color-primary) 18%, transparent);\n    }\n  }\n\n  &--delete {\n    color: var(--ion-color-danger);\n    background: color-mix(in srgb, var(--ion-color-danger) 10%, transparent);\n\n    &:hover {\n      background: color-mix(in srgb, var(--ion-color-danger) 18%, transparent);\n    }\n  }\n}\n\n// Issue #3002 — area esito verifica disponibilità numero / flusso \"ordine bis\".\n.verifica-esito {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin: 0.25rem 0 0.5rem;\n\n  ion-note {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    font-size: 0.85rem;\n  }\n\n  .verifica-occupato {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
